module.exports = __webpack_public_path__ + "img/bdqy.5f6c8cd8.png";